import React, { useEffect, useState } from "react";
import ImageComponent from "@src/stories/elements/Image/Image";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import 'photoswipe/style.css';

const Thumbnail = ({
  images,
  onImageClick,
  galleryType,
  videoUrl,
  isGiftCard,
}) => {
  const [selectedImage, setSelectedImage] = useState(images[0]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: ".product-image-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  return (
    <div className="product-image-gallery">
      <div className="thumbnail-list">
        {images.map((image, index) => (
          <div
            key={index}
            className={`thumbnail-item ${selectedImage === image ? "selected" : ""}`}
            onClick={() => setSelectedImage(image)}
          >
            <ImageComponent
              imageUrl={image.url}
              alt={image.alt || 'Product thumbnail'}
              isLazy={index > 3} // Don't lazy load first few thumbnails
              classes="w-full h-full object-cover"
              sizes="120px"
              aspectRatio="1/1"
            />
          </div>
        ))}
      </div>
      <div className="main-image">
        <a
          key={selectedImage.index}
          href={selectedImage.url}
          data-pswp-src={selectedImage.url}
          data-pswp-width={selectedImage.width || 2000}
          data-pswp-height={selectedImage.height || 3000}
          data-cropped="true"
        >
          <ImageComponent
            imageUrl={selectedImage.url}
            alt={selectedImage.alt || 'Product main image'}
            isLazy={false} // Main image should not be lazy loaded
            priority={true} // High priority for main product image
            classes="w-full h-full object-cover"
            sizes="(max-width: 768px) 100vw, 60vw"
            aspectRatio="4/5"
          />
        </a>
      </div>
    </div>
  );
};

export default Thumbnail;
